import { gql } from 'react-apollo';

export default gql`
  mutation startInvestorAccreditation {
    startInvestorAccreditation {
      _id
      accreditationStatus
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/startInvestorAccreditation.js